import { render, staticRenderFns } from "./MealRestrictionSummary.vue?vue&type=template&id=0500678a&"
import script from "./MealRestrictionSummary.vue?vue&type=script&lang=js&"
export * from "./MealRestrictionSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports